<script setup lang="ts">
  const promotionalBannerStory = await useFetchDataFromStoryblok('main-navigation/promotional-banner')
</script>

<template>
  <LazyPromotionalBanner
    v-if="promotionalBannerStory"
    :blok="promotionalBannerStory"
  />
</template>
